module.exports = __webpack_public_path__ + "/static/assets/34c084502bb019c82ef5f1a5aa2c4be2.gif";